const { atob, btoa, decodeURIComponent, encodeURIComponent } = window;
import { getActiveSubscription } from '@/data/session/session-globals';
const DESIGNER_URL_STORAGE_BASE_KEY = 'guide.designer.urls';
const VDS_BUCKET = 'in-app-designer';
const ADOPT_STUDIO_BUCKET = 'adopt-studio';

export const DESIGNER_LAUNCH_TOKEN_LS_KEY = 'pendo-designer-launch-token';

// eslint-disable-next-line internal-rules/no-hardcoded-colors
export const LOCAL_STORAGE_WHITE_LABEL_KEY = 'adopt-white-label-token';

export function generateDesignerToken (config) {
    return encodeURIComponent(btoa(JSON.stringify(config)));
}

export function parseDesignerToken (token) {
    if (!token) {
        return {};
    }

    return JSON.parse(atob(decodeURIComponent(token)));
}

export function getDesignerOpenerUrl (appUrl, config) {
    const token = generateDesignerToken(config);

    const urlHasQuery = appUrl.includes('?');
    let next = appUrl;

    if (urlHasQuery) {
        next += `&pendo-designer=${token}`;
    } else {
        next += `?pendo-designer=${token}`;
    }

    return next;
}

export function getDesignerLocationKeyForApp (appId = '-323232') {
    return `${DESIGNER_URL_STORAGE_BASE_KEY}.${getActiveSubscription()?.id}.${appId}`;
}

export function clearAllDesignerLocations (storage) {
    return Promise.all(
        [getDesignerLocationKeyForApp(), DESIGNER_URL_STORAGE_BASE_KEY].map((key) => storage.set(key, '')),
    );
}

export function getStaticPathPattern () {
    return new RegExp(/\/in-app-designer+\/([^]*)\/designer.html/);
}

export function isStaticDesignerPath (url = '') {
    const staticPathRegex = getStaticPathPattern();

    return staticPathRegex.test(url);
}

export function appendHttpsToUrl (url) {
    if (!url.startsWith('https://') && !url.startsWith('http://')) {
        return `https://${url}`;
    }

    return url;
}

export function convertToStaticLookasideConfigIfEligible (config = {}) {
    if (isStaticDesignerPath(config.host)) {
        config = {
            ...config,
            ...generateLaunchParamsForStaticDeploy(config.host),
        };
    }

    return config;
}

export function generateAdoptStudioLaunchParams (url) {
    return generateLaunchParamsForStaticDeploy(url, ADOPT_STUDIO_BUCKET);
}

export function generateVDSLaunchParams (url) {
    return generateLaunchParamsForStaticDeploy(url, VDS_BUCKET);
}

export function generateLaunchParamsForStaticDeploy (url, gcsBucket = VDS_BUCKET) {
    if (!url) {
        return { gcsBucket };
    }

    const buildUrl = new URL(appendHttpsToUrl(url));

    const { pathname, host } = buildUrl;

    const [, gcsBucketOverride, target] = pathname.split('/');

    return {
        gcsBucket: gcsBucketOverride || gcsBucket,
        target,
        host: appendHttpsToUrl(host),
    };
}
